import { lazy } from "react";

const Home = lazy(() => import("./Home/Home"));
const PrivacyPolicy = lazy(() => import("./Others/PrivacyPolicy"));
const Referral = lazy(() => import("./Referral/Referral"));

export { Home, PrivacyPolicy, Referral };
